export default "__VITE_ASSET__CeYXj1eo__"